import Vue from 'vue'
import Router from 'vue-router'

import mainView from '../mainView'

import error404 from '../views/samples/error-pages/error_404'
import error500 from '../views/samples/error-pages/error_500'

import { getCookie } from '@/helpers/cookie'
import { hasPendingTenants } from '@/helpers/auth'

Vue.use(Router)

const router = new Router({
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  mode: 'hash',
  routes: [{
    path: '/',
    redirect: '/inicio',
    component: mainView,
    children: [
      {
        path: '/login',
        name: 'login',
        components: {
          appHeader: () => import('../components/partials/AppHeader/NoLoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/NoLoggedUser.vue'),
          appContent: () => import('../views/login.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresNonAuth: true }
      },
      {
        path: '/tenant-select',
        name: 'tenant-select',
        components: {
          appHeader: () => import('../components/partials/AppHeader/NoLoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/NoLoggedUser.vue'),
          appContent: () => import('../views/tenantSelect.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { tenantSelection: true }
      },
      {
        path: '/inicio',
        name: 'home',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/home.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true }
      },
      { path: '/regionais', redirect: '/regionais/lista' },
      {
        path: '/regionais/:action',
        name: 'regional',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/regional.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      },
      { path: '/cargos', redirect: '/cargos/lista' },
      {
        path: '/cargos/:action',
        name: 'cargo',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/cargo.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      },
      { path: '/campanhas', redirect: '/campanhas/lista' },
      {
        path: '/campanhas/:action',
        name: 'campaign',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/campaign.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      },
      {
        path: '/motores-de-campanha/:action',
        name: 'campaignEngines',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/campaignEngines.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      },
      { path: '/relatorios', redirect: '/relatorios/lista' },
      {
        path: '/relatorios/:action',
        name: 'reports',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/reports.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      },
      { path: '/cashback', redirect: '/cashback/aprovar' },
      {
        path: '/cashback/:action',
        name: 'cashback',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/cashback.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      },
      { path: '/pontos', redirect: '/pontos/transferencia' },
      {
        path: '/pontos/:action',
        name: 'points',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/points.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador', 'SAC'] }
      },
      { path: '/selos', redirect: '/selos/consultar' },
      {
        path: '/selos/:action',
        name: 'seals',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/seals.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador', 'SAC', 'Estoque'] }
      },
      { path: '/tokens', redirect: '/tokens/consultar' },
      {
        path: '/tokens/:action',
        name: 'tokens',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/tokens.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador', 'SAC'] }
      },
      {
        path: '/documentos',
        name: 'documents',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/documents.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador', 'SAC'] }
      },
      { path: '/products', redirect: '/produtos/lista' },
      {
        path: '/produtos/:action',
        name: 'products',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/products.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      },
      { path: '/empresas', redirect: '/empresas/lista' },
      {
        path: '/empresas/:action',
        name: 'companies',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/companies.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador', 'SAC'] }
      },
      { path: '/banner', redirect: '/banner/lista' },
      {
        path: '/banner/:action',
        name: 'banner',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/banner.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      },
      { path: '/midia', redirect: '/midia/lista' },
      {
        path: '/midia/:action',
        name: 'downloadCenter',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/downloadCenter.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      },
      { path: '/galeria', redirect: '/galeria/lista' },
      {
        path: '/galeria/:action',
        name: 'gallery',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/gallery.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      },
      { path: '/noticias', redirect: '/noticias/lista' },
      {
        path: '/noticias/:action',
        name: 'news',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/news.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      },
      { path: '/categoria', redirect: '/categoria/lista' },
      {
        path: '/categoria/:action',
        name: 'memberCategory',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/memberCategory.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      },
      { path: '/categoria-empresas', redirect: 'categoria-empresas/atualizar' },
      {
        path: '/categoria-empresas/:action',
        name: 'companiesCategory',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/companiesCategory.vue'),
          // appContent: () => import('../views/campaign.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      },
      { path: '/cargo-campanha', redirect: '/cargo-campanha/lista' },
      {
        path: '/cargo-campanha/:action',
        name: 'jobTitleCampaign',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/jobTitleCampaign.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      },
      { name: 'users', path: '/usuarios', redirect: '/usuarios/lista' },
      {
        path: '/usuarios/:action',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/users.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador', 'SAC'] }
      },
      {
        path: '/tenants',
        name: 'tenants',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/tenant.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true }
      },
      { path: '/vendas', redirect: '/vendas/lista' },
      {
        path: '/vendas/:action',
        name: 'vendas',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/vendas.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador', 'SAC'] }
      },
      { path: '/metas', redirect: '/metas/lista' },
      {
        path: '/metas/:action',
        name: 'metas',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/metas.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador', 'SAC'] }
      },
      { path: '/atingimento-metas', redirect: '/atingimento-metas/consultar' },
      {
        path: '/atingimento-metas/:action',
        name: 'atingimentoMetas',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/atingimentoMetas.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador', 'SAC'] }
      },
      { path: '/folha-pagamento', redirect: '/folha-pagamento/lista' },
      {
        path: '/folha-pagamento/:action',
        name: 'folha-pagamento',
        components: {
          appHeader: () => import('../components/partials/AppHeader/LoggedUser.vue'),
          appSidebar: () => import('../components/partials/AppSidebar/LoggedUser.vue'),
          appContent: () => import('../views/payroll.vue'),
          appFooter: () => import('../components/partials/AppFooter.vue')
        },
        meta: { requiresAuth: true, roles: ['Administrador'] }
      }
    ]
  },
  {
    path: '*',
    redirect: '/pages/error_404',
    component: {
      render (c) { return c('router-view') }
    },
    children: [
      {
        path: '/pages/error_404',
        component: error404
      },
      {
        path: '/pages/error_500',
        component: error500
      }
    ]}
  ]
})

function isFullyAuthenticated () {
  return getCookie('token') != null && getCookie('tenantId') != null
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.tenantSelection)) {
    if (isFullyAuthenticated()) {
      next({ name: 'home' })
    } else if (hasPendingTenants()) {
      next()
    } else {
      next({ name: 'login' })
    }
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    if (getCookie('token') == null) next({ name: 'login' })
    else next()
  } else if (to.matched.some(record => record.meta.requiresNonAuth)) {
    if (isFullyAuthenticated()) next({ name: 'home' })
    else next()
  } else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js